import React from 'react';
import { Box, Heading, Text, Link } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import SectionTitle from '../../components/shared/SectionTitle';
import TwoColumns from '../../components/shared/TwoColumns';

const OurChallengesSection = () => (
  <Box id="our-values" background="rgba(249, 252, 255, 0.8)" py="20">
    <Box maxW="5xl" mx="auto">
      <SectionTitle
        title="Our Values: Think. Do. Serve."
        subTitle="“And while we build a new category of platform and data, we also aim to build a different kind of company. It’s working: I’ll stack our team against any, and fight with a happy heart knowing we can’t lose if we stick to our shared team values. ” -A.J., HOVER Founder & CEO"
      />
    </Box>
    <TwoColumns
      reverseOrderInMobile
      maxColWidth="600px"
      col1={
        <Box>
          <Heading>Think.</Heading>
          <Text my="10" fontSize="lg">
            Think. We share our diverse perspectives, question assumptions, and
            push each other to innovate. From hackathons to retrospectives, our
            problem-solving approach results in products that are evolving the
            way home improvement happens for homeowners and professionals.
          </Text>
        </Box>
      }
      col2={
        <StaticImage
          placeholder="blurred"
          src="../../images/our_values_1-min.jpg"
          alt="People around a table"
        />
      }
    />
    <TwoColumns
      maxColWidth="600px"
      col1={
        <StaticImage
          placeholder="blurred"
          src="../../images/our_values_2-min.jpg"
          alt="Hover employees working at desks"
        />
      }
      col2={
        <Box>
          <Heading>Do.</Heading>
          <Text my="10" fontSize="lg">
            Do. We have a strong bias towards action. We work to transform great
            thinking into products that wow our customers, and we learn and
            adapt along the way. We don&apos;t get bogged down by indecision;
            instead we pick a path and follow through.
          </Text>
        </Box>
      }
    />
    <TwoColumns
      reverseOrderInMobile
      maxColWidth="600px"
      col1={
        <Box>
          <Heading>Serve.</Heading>
          <Text my="10" fontSize="lg">
            Serve. We are guided by the principles of servant leadership and
            transparency in all we do. Whether working with our fellow
            HOVERites, providing exceptional experiences for our customers, or
            engaging in company-supported community work, empowering others
            through service is central to our company culture.
          </Text>
        </Box>
      }
      col2={
        <Link
          href="https://www.forbes.com/americas-best-startup-employers/#3a002ed46527"
          target="_blank"
        >
          <StaticImage
            placeholder="blurred"
            src="../../images/our_values_3-min.png"
            alt="People wearing blue shirts"
          />
        </Link>
      }
    />
  </Box>
);

export default OurChallengesSection;
